import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { scrollToSection } from "@/components/Navbar";

export default function FinancingHero() {
  return (
    <section className="relative min-h-[92svh] overflow-hidden flex items-end" data-testid="financing-hero">
      <motion.img
        src="/images/comm-multi-1.jpg"
        alt="Multifamily apartment building at dusk with warm interior lighting"
        initial={{ opacity: 0, scale: 1.06 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
        className="absolute inset-0 w-full h-full object-cover"
        data-testid="financing-hero-image"
      />
      <div className="absolute inset-0 bg-black/55" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-black/40 to-black/45" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/10 to-transparent" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-48 pb-24 sm:pb-28">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.3 }}
          className="text-[11px] sm:text-xs tracking-[0.45em] uppercase text-[#D4AF37] mb-6"
          data-testid="financing-hero-overline"
        >
          Commercial Real Estate &amp; Development Financing
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.45 }}
          className="font-display text-4xl sm:text-6xl lg:text-7xl font-light leading-[1.02] tracking-tight text-[#F5F5F5]"
          data-testid="financing-hero-headline"
        >
          Capital Solutions Built
          <br />
          <span className="italic text-[#D4AF37]">Around the Deal.</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.6 }}
          className="mt-8 max-w-xl text-base sm:text-lg font-light leading-relaxed tracking-wide text-[#A3A3A3]"
          data-testid="financing-hero-subtext"
        >
          Connecting qualified real estate projects with construction, acquisition, bridge and development capital — through our financing relationships, for developers, investors and property owners.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.75 }}
          className="mt-10 flex flex-col sm:flex-row gap-4"
        >
          <button
            onClick={() => scrollToSection("#funding-form")}
            data-testid="submit-project-hero-button"
            className="bg-[#D4AF37] text-black px-10 py-4 text-[11px] tracking-[0.3em] uppercase font-medium hover:bg-[#F3E5AB] transition-colors duration-300"
          >
            Submit Your Project
          </button>
          <a
            href="tel:+18164056181"
            data-testid="financing-hero-call-button"
            className="flex items-center justify-center gap-2.5 border border-[#D4AF37]/40 text-[#D4AF37] px-10 py-4 text-[11px] tracking-[0.3em] uppercase hover:bg-[#D4AF37] hover:text-black transition-colors duration-300"
          >
            <Phone size={13} strokeWidth={1.5} />
            816-405-6181
          </a>
        </motion.div>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9, delay: 0.9 }}
          className="mt-10 max-w-xl text-[10px] font-light leading-relaxed tracking-[0.12em] uppercase text-[#A3A3A3]/70"
          data-testid="financing-hero-disclosure"
        >
          Veritas Development Group LLC arranges capital through a network of third-party lending and capital-market professionals, acting in a broker and advisory capacity. Veritas is not a direct lending financial institution.
        </motion.p>
      </div>
    </section>
  );
}
